import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full bg-ink text-white" data-id="element-0" data-mp="31bs1ff0jszn8">
      <MetaPixel data-id="element-1" data-mp="2wk09b01quluz" />
      <main data-id="element-2" data-mp="2wjgrrkg09zhh">
        <Hero data-id="element-3" data-mp="2wjql9i09eorx" />
        <Stats data-id="element-4" data-mp="2wj8e3qc26q58" />
        <Testimonials data-id="element-5" data-mp="2wip54z4dzc3c" />
        <PainPoints data-id="element-6" data-mp="2wi5qbra193tj" />
        <Tomos data-id="element-7" data-mp="28tw62tsgwo4i" />
        <Bonuses data-id="element-8" data-mp="28tmifcuwat1z" />
        <Countdown data-id="element-9" data-mp="28t4jg8gum0qd" />
        <Pricing data-id="element-10" data-mp="28sbb5328r364" />
        <FAQ data-id="element-11" data-mp="23vcjcr61v8b3" />
        <ValueStack data-id="element-12" data-mp="23vktwcepa1j4" />
      </main>
      <Footer data-id="element-13" data-mp="23ujk0b9f7l2z" />
    </div>;
}